/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Requester_Order_BuyerInputs */

const en_claim_requester_order_buyer = /** @type {(inputs: Claim_Requester_Order_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buyer of the order`)
};

/**
* | output |
* | --- |
* | "The buyer of the order" |
*
* @param {Claim_Requester_Order_BuyerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_requester_order_buyer = /** @type {((inputs?: Claim_Requester_Order_BuyerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Requester_Order_BuyerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_requester_order_buyer(inputs)
});